import Graph from 'graph-data-structure';
import { FLOW_STEPS } from '../../constants';

const UserGraph = Graph();

UserGraph.addNode(FLOW_STEPS.WELCOME);
UserGraph.addNode(FLOW_STEPS.EMAIL_SIGNUP);
UserGraph.addNode(FLOW_STEPS.EMAIL_LOGIN);
UserGraph.addNode(FLOW_STEPS.PASSWORD_RESET_LINK);

// ** email flow **
// email signup
UserGraph.addEdge(FLOW_STEPS.WELCOME, FLOW_STEPS.EMAIL_SIGNUP);
// email login
UserGraph.addEdge(FLOW_STEPS.WELCOME, FLOW_STEPS.EMAIL_LOGIN);
// reset password from email login
UserGraph.addEdge(FLOW_STEPS.EMAIL_LOGIN, FLOW_STEPS.PASSWORD_RESET_LINK);

// ** mobile otp flow **
// verify phone number
UserGraph.addEdge(FLOW_STEPS.WELCOME, FLOW_STEPS.VERIFY_PHONE_NUMBER);
// phone signup
UserGraph.addEdge(FLOW_STEPS.VERIFY_PHONE_NUMBER, FLOW_STEPS.PHONE_SIGNUP);
// phone signup => email login
UserGraph.addEdge(FLOW_STEPS.PHONE_SIGNUP, FLOW_STEPS.EMAIL_LOGIN);
// verify email
UserGraph.addEdge(FLOW_STEPS.VERIFY_PHONE_NUMBER, FLOW_STEPS.VERIFY_EMAIL);
// verify email => phone signup
UserGraph.addEdge(FLOW_STEPS.VERIFY_EMAIL, FLOW_STEPS.PHONE_SIGNUP);

// ** singpass flow **
// render singpass qr code
UserGraph.addEdge(FLOW_STEPS.WELCOME, FLOW_STEPS.SINGPASS);

export default UserGraph;
